import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { EsqepBuildVersionsResponse } from '../../models/build-versions/esqep-build-versions-response';

const dotNetServerUri = environment.serverUrl;

@Injectable({
  providedIn: 'root',
})
export class BuildVersionsService {
  private http = inject(HttpClient);

  getBuildVersions(): Observable<EsqepBuildVersionsResponse> {
    return this.http
      .get<
        EsqepBuildVersionsResponse
      >(`${dotNetServerUri}/buildVersions`)
      .pipe(
        map((resp) => resp),
        catchError((err) => {
          return throwError(() => new Error(err))
        }),
      );
  }
}
